import { darkBackgroundBlur } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  max-width: 100%;
`;

interface SuggestionsWrapperProps {
  allowHorizontalDropdownGrowth: boolean;
  fullPageSuggestions: boolean;
}

export const SuggestionsWrapper = styled.div<SuggestionsWrapperProps>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  height: auto;
  border-radius: ${themeStyle.radiusLarge};
  background: ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.varShadowMedium};
  z-index: 1;
  overflow: hidden;

  ${({ allowHorizontalDropdownGrowth }) =>
    allowHorizontalDropdownGrowth &&
    `
      inline-size: max-content;
      max-width: calc(100vw - 50px);
  `}

  ${({ fullPageSuggestions }) =>
    fullPageSuggestions &&
    `
    position: fixed;
    top: calc(100% + 14px);
    left: -41px;
    width: 100vw;
    height: calc(100vh - (100% - 14px));
    border-radius: 0;
  `}

  * {
    user-select: none;
  }

  ${darkBackgroundBlur}
`;

interface SuggestionProps {
  height?: string;
  isActive?: boolean;
  cursor?: string;
}

export const Suggestion = styled.div<SuggestionProps>`
  height: ${({ height }) => height};
  display: flex;
  align-items: center;

  text-align: left;

  H5:last-of-type {
    white-space: pre;
  }

  background: ${({ isActive }) =>
    isActive ? themeStyle.varInkSuperLight : 'transparent'};

  margin: 0 -16px;
  padding: 0 16px;

  flex-wrap: wrap;

  cursor: ${({ cursor }) => (cursor ? cursor : 'pointer')};
  * {
    cursor: ${({ cursor }) => (cursor ? cursor : 'pointer')};
  }
`;

export const Section = styled.div`
  padding: 8px 16px;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${themeStyle.varInkSuperLight};
  }
`;
